export const tailLayout = {
	wrapperCol: {
		offset: 0,
		span: 24,
	},
};
